import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VRow,{staticStyle:{"background":"#F2FBFC"},attrs:{"align":"center","justify":"center"}},[_c(VCol,{staticClass:"col-sm-8 col-xs-12 pa-0"},[_c('stepper_top')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }